import React, {createContext} from 'react';

import axios from 'axios';


export const MspContext = createContext();

class MspContextProvider extends React.Component {

    constructor(props) {
        super(props);
        const obj = {
            isLoading: true,
            isChecking:true,
            sso:false,
            accessData:{}
        };

        if ('sso' in props) {
            obj.sso = props.sso;
        }

        this.state = obj;
    }

    componentDidMount() {
        this.loadData(this);
    }

    loadData(){

        if(this.state.sso){
            const apiPath = `${process.env.REACT_APP_API_URL}/connect/mspcode`;

            axios.post(apiPath,{
                goToken:JSON.parse(atob( this.state.sso ))
            },{
                timeout: 30000,
            }).then(res => {

                this.setState({
                    isChecking:false,
                    accessData:res.data,
                })

            }).catch(() => {
                localStorage.setItem('mspFail',true);
                this.setState({
                    isChecking:false,
                    accessData:false,
                })
            });
        }

    }

    render() {
        return (
            <MspContext.Provider value={{
                ...this.state,
                setState:this.setState.bind(this)
            }}>
                {this.props.children}
            </MspContext.Provider>
        );
    }
}

export default MspContextProvider;